import { Container } from 'pixi.js';
import { Signal } from 'typed-signals';
import { applyLayoutState, resetLayout } from 'libs/layouts/populateLayouts/applyLayoutState';
import type { ResourceMap } from '../../../app/resources/types';
import { RewardBubbleView } from '../../../views/RewardBubbleView';
import { SpeechBubbleSide } from '../../../views/SpeechBubbleView';
import { DioramaChestLayout } from '../../../../layouts/dioramas/DioramaChestLayout';

interface DioramaChestViewConfig {
  reward: ResourceMap;
  isCompleted: boolean;
}

export class DioramaChestView extends Container {
  public readonly onClicked = new Signal();

  private readonly layout = new DioramaChestLayout();

  private rewardBubble: RewardBubbleView | null = null;

  constructor(
    rootContainer: Container
  ) {
    super();
    
    const { root, chest } = this.layout;
    root.props({ parent: rootContainer });

    chest.on('pointertap', () => {
      this.onClicked.emit();
    });
  }

  public setDioramaChestConfig(config: DioramaChestViewConfig): void {
    this.rewardBubble?.destroy();
    this.rewardBubble = null;

    if (config.isCompleted) {
      applyLayoutState(this.layout, 'opened');
    } else {
      resetLayout(this.layout);

      this.rewardBubble = new RewardBubbleView({
        pointer: { side: SpeechBubbleSide.Top, anchor: 1 },
        rewards: config.reward,
      }).props({
        parent: this.layout.rewardBubbleSlot,
        visible: false
      });
    }
  }

  public toggleRewardBubble(value: boolean): void {
    if (this.rewardBubble !== null) {
      this.rewardBubble.visible = value;
    }
  }
}
